// extracted by mini-css-extract-plugin
export default {"body":"AuctionSettingsModal_body__TggzI","inputs":"AuctionSettingsModal_inputs__3bPwO","saveButton":"AuctionSettingsModal_saveButton__x8sI0"};